/* eslint-disable import/no-unresolved */
import React from "react";
import UserOrderList from "components/pages/user/orders/UserOrderList";

const WholesaleUserOrderList = (props) => {

    return (
        <div>
            <UserOrderList {...props} wholesale={true} />
        </div>
    );
};

export default (WholesaleUserOrderList);
